import { useRouter } from 'next/router'

const useQueryString = () => {
  const router = useRouter()
  const query = router.asPath.split('?')?.[1] ?? ''
  return query ? `?${query}` : ''
}

export default useQueryString
